import InformeAuditoria from './views/InformeAuditoriaView.vue'
import InformesAuditoriasListView from './views/InformeAuditoriaListView.vue'
import InformeAuditoriaPartidoListView from './views/InformeAuditoriaPartidoListView.vue'
import InformeAuditoriaPartidoSelector from './views/InformeAuditoriaPartidoSelector.vue'
import InformesAuditoriasClubListView from './views/InformeAuditoriaClubListView.vue'

export default [
  {
    path: '/selector',
    name: 'selector',
    component: InformeAuditoriaPartidoSelector,
    children: [

      {
        path: 'todos',
        name: 'selector-todos',
        component: InformeAuditoriaPartidoListView
      },
      {
        path: 'primera/:id',
        name: 'selector-primera',
        component: InformeAuditoriaPartidoListView
      },
      {
        path: 'proyeccion/:id',
        name: 'selector-proyeccion',
        component: InformeAuditoriaPartidoListView
      }
    ]
  },
  {
    path: '/informe-auditoria',
    name: 'informes-auditorias',
    component: InformesAuditoriasListView
  },
  {
    path: '/informe-auditoria/:id',
    name: 'informe-auditoria',
    component: InformeAuditoria
  },
  {
    path: '/informe-auditoria-club',
    name: 'informes-auditorias-club',
    component: InformesAuditoriasClubListView
  }

]
